import update from 'immutability-helper';
import React, { useCallback } from 'react';
import { ItemStyle, ListStyle, DataProps, RenderItem } from './interface';
import SubMenu from './SubMenu';
import MenuItem from './MenuItem';
interface IListProps extends ItemStyle,ListStyle,DataProps, RenderItem{
    changeCardList: (list: any[]) => void;
}

const List: React.FC<IListProps> = ({
    type, 
    moveEnd, 
    dataList, 
    changeCardList, 
    itemClassName, 
    itemStyle, 
    itemHoverStyle, 
    listClassName, 
    listStyle, 
    renderItem,
    renderMenu
}) => {
    const moveCard = useCallback((dragIndex: number, hoverIndex: number, category?: { index: number, children: Array<any> } ) => {
        console.log(dragIndex);
        console.log(hoverIndex);
        if(dragIndex !== undefined) {
            if(category) { //分类下拖拽时
                const childIndex = category.index;
                const dragCard = category.children[dragIndex];
                changeCardList(update(dataList, {
                    [childIndex]: {
                        children: children =>
                            update(children, {
                                $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]],
                            })
                    }
                }));
            }else {
                const dragCard = dataList[dragIndex];
                changeCardList(update(dataList, {
                    $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]],
                }));
            }
        }
    }, [dataList]);

    const renderCard = (menusTree, parent?) => {
        return menusTree && menusTree.map((item, index) => {
            if (!item) {
                return null;
            }
            const childList = item.children;
            item.index = index;
            // 父菜单
            if (childList && childList.length) {
                return (
                    <SubMenu
                        type={"menu"}
                        index={ index } 
                        key={ item.id || index } 
                        dataList={ dataList } 
                        category={item}
                        moveCard={ moveCard }
                        itemHoverStyle={ itemHoverStyle }
                        itemClassName={ itemClassName }
                        itemStyle={ itemStyle }
                        moveEnd={ moveEnd }
                        renderItem={renderItem}
                        renderMenu={renderMenu}
                    >
                        {renderCard(childList, item)}
                    </SubMenu>
                );
            }
            // 子菜单 
            return (
                <MenuItem 
                    type={"item"}
                    index={ index } 
                    key={ item.id || index } 
                    dataList={ dataList } 
                    moveCard={ moveCard }
                    itemHoverStyle={ itemHoverStyle }
                    itemClassName={ itemClassName }
                    itemStyle={ itemStyle }
                    moveEnd={ moveEnd }
                    category={parent}
                    renderItem={renderItem}
                />
            );
        });
    };

    return (
        <div style={listStyle} className={listClassName}>
            {
                renderCard(dataList)
            }
        </div>
    );
};

export default List;


// WEBPACK FOOTER //
// ./src/display/components/Drop/List.tsx